import * as Yup from 'yup'

Yup.setLocale({
   mixed: {
      required: 'TRANSLATION:validation.required',
   },

   string: {
      email: 'TRANSLATION:validation.email',
      max: 'TRANSLATION:validation.max',
      min: 'TRANSLATION:validation.min',
   },
})

export { Yup }
